// components/organization/EditUserModal.jsx
import React, { useEffect, useState } from "react";
import { httpRequest } from "../../utils/httpRequest";
import { toast } from "react-toastify";
import PermissionSelector from "./PermissionSelector";
import CategoryScopeSelector from "./CategoryScopeSelector"; // ⬅️ اضافه شد

const EditUserModal = ({ user, isOpen, onClose, onSaved }) => {
  const token = JSON.parse(localStorage.getItem("user"))?.token;
  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    tags: "",
    permissions: [],
    categoryScopes: [], // ⬅️ اضافه شد
  });

  // کمک‌تابع: هر ورودی را به لیست id (رشته) تبدیل می‌کند
  const toIdList = (arr) =>
    Array.isArray(arr)
      ? arr
          .map((x) =>
            // ممکنه بک‌اند کل شیء Category رو برگردونه یا فقط id
            typeof x === "string" ? x : x?._id || x?.id || null
          )
          .filter(Boolean)
          .map(String)
      : [];

  useEffect(() => {
    if (!isOpen || !user) return;

    setForm({
      name: user.name || "",
      phone: user.phone || "",
      email: user.email || "",
      tags: Array.isArray(user.tags) ? user.tags.join(",") : "",
      permissions: Array.isArray(user.permissions)
        ? user.permissions
            .map((p) => (typeof p === "string" ? p : p?.key))
            .filter(Boolean)
        : [],
      categoryScopes: toIdList(user.categoryScopes), // ⬅️ پرشدن مقادیر اولیه
    });
  }, [isOpen, user]);

  if (!isOpen || !user) return null;

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        name: form.name,
        phone: form.phone,
        email: form.email ? form.email : undefined,
        tags: form.tags
          .split(",")
          .map((t) => t.trim())
          .filter(Boolean),
        permissions: form.permissions, // آرایهٔ کلیدها
        categoryScopes: toIdList(form.categoryScopes), // ⬅️ ارسال اسکوپ‌ها
      };

      await httpRequest("PATCH", `/user/${user._id}`, payload, {
        "x-access-token": token,
      });

      toast.success("اطلاعات کاربر به‌روزرسانی شد");
      onSaved?.();
      onClose?.();
    } catch (err) {
      toast.error(err?.response?.data?.message || "خطا در به‌روزرسانی کاربر");
    } finally {
      setLoading(false);
    }
  };

  console.log(form);

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-50"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-2xl shadow-lg w-full max-w-2xl p-6 space-y-4 max-h-[80vh] overflow-y-scroll"
      >
        <h2 className="text-lg font-bold text-gray-800">ویرایش کاربر</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* اطلاعات پایه */}
          <div className="grid grid-cols-1 gap-3">
            <div>
              <label className="block text-sm mb-1">نام</label>
              <input
                name="name"
                value={form.name}
                onChange={handleChange}
                className="w-full border rounded-md px-3 py-2"
              />
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <label className="block text-sm mb-1">موبایل</label>
                <input
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  className="w-full border rounded-md px-3 py-2"
                />
              </div>
              <div>
                <label className="block text-sm mb-1">ایمیل</label>
                <input
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  className="w-full border rounded-md px-3 py-2"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm mb-1">
                تگ‌ها (با کاما جدا کن)
              </label>
              <input
                name="tags"
                value={form.tags}
                onChange={handleChange}
                className="w-full border rounded-md px-3 py-2"
                placeholder="teacher, editor"
              />
            </div>
          </div>

          {/* دسترسی‌های اکشنی */}
          <PermissionSelector
            selected={form.permissions}
            onChange={(perms) => setForm((f) => ({ ...f, permissions: perms }))}
          />

          {/* دسترسی به دسته‌بندی‌ها (اسکوپ) */}
          <CategoryScopeSelector
            selected={form.categoryScopes}
            onChange={(ids) => setForm((f) => ({ ...f, categoryScopes: ids }))}
            title="اسکوپ دسته‌بندی (Content Scope)"
            hint="کاربر فقط به دسته‌های انتخاب‌شده و تمام فرزندان‌شان دسترسی خواهد داشت."
          />

          {/* اکشن‌ها */}
          <div className="flex justify-end gap-2 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-600 bg-gray-200 rounded-lg"
            >
              انصراف
            </button>
            <button
              type="submit"
              disabled={loading}
              className={`px-4 py-2 rounded-lg text-white bg-purple-600 hover:bg-purple-700 transition ${
                loading ? "opacity-60 cursor-not-allowed" : ""
              }`}
            >
              {loading ? "در حال ذخیره..." : "ذخیره"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditUserModal;
